<!-- building-modal.component.html -->
<div class="modal fade" [class.show]="isVisible" [class.d-block]="isVisible" tabindex="-1"
  aria-labelledby="buildingModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" 
       [style.max-height]="modalHeight"
       style="max-width: 1000px; margin: 1rem auto;">
    <div class="modal-content h-100">
      <div class="modal-header">
        <h5 class="modal-title" id="buildingModalLabel">{{title}}</h5>
        <button type="button" class="btn-close text-white" aria-label="Close" (click)="close()"></button>
      </div>
      <div class="modal-body p-0">
        <!-- Keterangan legend di bagian bawah -->
        <div class="legend-footer">
            <div class="legend-title">Keterangan Warna:</div>
            <div class="legend-grid">
                <div class="legend-footer-item">
                    <span class="legend-color segment-group-paid"></span>
                    <span class="legend-text">Group - Paid</span>
                </div>
                <div class="legend-footer-item">
                    <span class="legend-color segment-group-unpaid"></span>
                    <span class="legend-text">Group - Unpaid</span>
                </div>
                <div class="legend-footer-item">
                    <span class="legend-color segment-non-group"></span>
                    <span class="legend-text">External</span>
                </div>
                <div class="legend-footer-item">
                    <span class="legend-color segment-default"></span>
                    <span class="legend-text">Vacant</span>
                </div>
                <div class="legend-footer-item">
                    <span class="legend-color segment-reserved"></span>
                    <span class="legend-text">Reserved</span>
                </div>
            </div>
        </div>
        
        <div class="building-data h-100">
          <ng-container *ngIf="groupedBuildingData && groupedBuildingData.length > 0; else noData">
            <div class="table-container">
              <div class="table-responsive h-100">
                <table class="table mb-0 floor-table">
                  <thead class="table-header sticky-top">
                    <tr>
                      <th scope="col" style="width: 10%" class="text-center">Floor</th>
                      <th scope="col" style="width: 90%" class="text-center">Tenant</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let floor of groupedBuildingData; let i = index" class="floor-row">
                      <td class="text-center floor-cell">
                        <div class="floor-number">{{ floor.floorName }}</div>
                        <div class="floorarea-number">
                          {{ floor.floorArea }}
                          <span *ngIf="floor.floorUom === 'sqm'; else otherUom">m²</span>
                          <ng-template #otherUom>{{ floor.floorUom }}</ng-template>
                        </div>
                      </td>
                      <td class="tenant-cell">
                        <div class="stacked-bar-container">
                          <div class="stacked-bar">
                            <div *ngFor="let tenant of floor.tenants" 
                                class="stacked-bar-segment"
                                [style.width.%]="tenant.pctg_usage"
                                [ngClass]="getSegmentClass(tenant.tenant_type)"
                                [title]="getSegmentTooltip(tenant)">
                              
                              <div class="segment-content" *ngIf="tenant.pctg_usage >= 8">
                                <div class="segment-text-center">
                                  <div class="tenant-name-center">
                                    {{ getShortTenantName(tenant.tenant_name) }}
                                  </div>
                                  <div class="usage-percentage-center">
                                    {{ tenant.used_area }} 
                                    <span *ngIf="floor.floorUom === 'sqm'; else otherUom">m²</span>
                                    <ng-template #otherUom>{{ floor.floorUom }}</ng-template>
                                  </div>
                                  <div *ngIf="tenant.used_area && tenant.pctg_usage >= 15" 
                                      class="sqm-value-center">
                                    {{ tenant.pctg_usage | number:'1.2-2' }}%
                                  </div>
                                </div>
                              </div>
                              
                              <div class="segment-content-small" *ngIf="tenant.pctg_usage >= 5 && tenant.pctg_usage < 8">
                                <div class="segment-text-center">
                                  <div class="tenant-name-center-small">
                                    {{ getShortTenantName(tenant.tenant_name, 12) }}
                                  </div>
                                  <div class="usage-percentage-center-small">
                                    {{ tenant.used_area }} 
                                    <span *ngIf="floor.floorUom === 'sqm'; else otherUom">m²</span>
                                    <ng-template #otherUom>{{ floor.floorUom }}</ng-template>
                                  </div>
                                </div>
                              </div>
                              
                              <div class="segment-tooltip" *ngIf="tenant.pctg_usage < 5">
                                <span class="tooltip-text">
                                  {{ getShortTenantName(tenant.tenant_name) }} {{ tenant.used_area }}
                                  <span *ngIf="floor.floorUom === 'sqm'; else otherUom">m²</span>
                                  <ng-template #otherUom>{{ floor.floorUom }}</ng-template>
                                </span>
                              </div>
                            </div>
                          </div>
                          
                          <div class="segment-legend" *ngIf="hasSmallSegments(floor.tenants)">
                            <ng-container *ngFor="let tenant of floor.tenants">
                              <div class="legend-item" *ngIf="tenant.pctg_usage < 5">
                                <span class="legend-color" [ngClass]="getSegmentClass(tenant.tenant_type)"></span>
                                <span class="legend-text">
                                  {{ getShortTenantName(tenant.tenant_name) }} ({{ tenant.used_area }}
                                  <span *ngIf="floor.floorUom === 'sqm'; else otherUom">m²</span>
                                  <ng-template #otherUom>{{ floor.floorUom }}</ng-template>)
                                </span>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-container>
          
          <ng-template #noData>
            <div class="no-data text-center py-4">
              <i class="fas fa-building fa-3x text-muted mb-3"></i>
              <p class="text-muted">No building data available</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>